import * as types from './constants';

// Get Lookbook Users
export const getLookbookUsersRequest = data => (
  { type: types.GET_LOOKBOOK_USERS_REQUEST, payload: data }
);

export const getLookbookUsersDone = data => (
  { type: types.GET_LOOKBOOK_USERS_DONE, payload: data }
);

export const getLookbookUsersFailed = errors => (
  { type: types.GET_LOOKBOOK_USERS_FAILED, payload: errors }
);

export const getLookbookUsersReset = () => (
  { type: types.GET_LOOKBOOK_USERS_RESET }
);
